import { createAction, props } from '@ngrx/store';

import { ProductPageStatus } from '../models/product-page.models';

import { Product, ProductColor, ProductError, ProductPrice, ProductSize } from '@api/catalog/products/products.models';
import { PreviousRouteNavigation } from '@shared/navigation/store/navigation.state';

export const ProductActionTypes = {
    INIT_PRODUCT_PAGE: '[product-page] INIT_PRODUCT_PAGE',
    LOAD_PRODUCT_PAGE: '[product-page] LOAD_PRODUCT_PAGE',
    LOAD_PRODUCT_PAGE_SUCCESS: '[product-page] LOAD_PRODUCT_PAGE_SUCCESS',
    LOAD_PRODUCT_PAGE_ERROR: '[product-page] LOAD_PRODUCT_PAGE_ERROR',
    SET_PRODUCT_PAGE_VIEWED: '[product-page] SET_PRODUCT_PAGE_VIEWED',
    SET_STATUS_PRODUCT_LOADED: '[product-page] SET_STATUS_PRODUCT_LOADED',
    SET_PREVIOUS_BACK: '[product-page] SET_PREVIOUS_BACK',
    REPLACE_STATE_URL_PRODUCT_PAGE: '[product-page] REPLACE_STATE_URL_PRODUCT_PAGE',
    PRODUCT_PAGE_ADD_TO_CART: '[product-page] PRODUCT_PAGE_ADD_TO_CART',
    PRODUCT_PAGE_ADD_TO_CART_SUCCESS: '[product-page] PRODUCT_PAGE_ADD_TO_CART_SUCCESS',
    CLEAR_PRODUCT_PAGE: '[product-page] CLEAR_PRODUCT_PAGE',
    SET_ENABLE_PURCHASE: '[product-page] SET_ENABLE_PURCHASE',
    SET_COLOR_ON_SELECTED_PRODUCT: '[product-page] SET_COLOR_ON_SELECTED_PRODUCT',
    SET_SIZE_ON_SELECTED_PRODUCT: '[product-page] SET_SIZE_ON_SELECTED_PRODUCT',
    RESET_SELECTED_PRODUCT_SIZE: '[product-page] RESET_SELECTED_PRODUCT_SIZE',
    LOAD_LAZY_WISHLIST_MODULE: '[product-page] LOAD_LAZY_WISHLIST_MODULE',
    LOAD_LAZY_DELIVERY_INFO_MODULE: '[product-page] LOAD_LAZY_DELIVERY_INFO_MODULE',
    OPEN_SIZE_GUIDE_MODULE: '[product-page] OPEN_SIZE_GUIDE_MODULE',
    PRODUCT_VIEW_ZOOM_IN_ANALYTICS: '[product-page] PRODUCT_VIEW_ZOOM_IN',
    // eslint-disable-next-line no-secrets/no-secrets
    PRODUCT_VIEW_NEXT_IMAGE_ANALYTICS: '[product-page] PRODUCT_VIEW_NEXT_IMAGE_ANALYTICS',
    SET_ERROR_PRODUCT_FAILED: '[product-page] SET_ERROR_PRODUCT_FAILED',
    UPDATE_PRODUCT_PRICE: '[product-page] UPDATE_PRODUCT_PRICE',
    UPDATE_PRODUCT_PRICE_SUCCESS: '[product-page] UPDATE_PRODUCT_PRICE_SUCCESS',
};

export const InitProductPage = createAction(
    ProductActionTypes.INIT_PRODUCT_PAGE
);

export const ClearProductPage = createAction(ProductActionTypes.CLEAR_PRODUCT_PAGE);

export const ProductPageAddToCartSuccess = createAction(
    ProductActionTypes.PRODUCT_PAGE_ADD_TO_CART_SUCCESS,
    props<{ product: Product; openPopup: boolean }>()
);

export const SetPreviousRouteProductPage = createAction(
    ProductActionTypes.SET_PREVIOUS_BACK,
    props<{ previousRoute: PreviousRouteNavigation }>()
);

export const ReplaceStateUrlProductPage = createAction(
    ProductActionTypes.REPLACE_STATE_URL_PRODUCT_PAGE,
    props<{ product: Product }>()
);

export const LoadProductPage = createAction(
    ProductActionTypes.LOAD_PRODUCT_PAGE,
    props<{ id: string; mocaCode?: string; categoryId: string; colorId: string; styleId: string }>()
);

export const SetStatusProductLoaded = createAction(
    ProductActionTypes.SET_STATUS_PRODUCT_LOADED,
    props<{ status: ProductPageStatus }>()
);

export const SetProductPurchaseAvailable = createAction(
    ProductActionTypes.SET_ENABLE_PURCHASE,
    props<{ purchaseAvailable: boolean }>()
);

export const LoadProductPageSuccess = createAction(
    ProductActionTypes.LOAD_PRODUCT_PAGE_SUCCESS,
    props<{ product: Product }>()
);

export const LoadProductPageError = createAction(
    ProductActionTypes.LOAD_PRODUCT_PAGE_ERROR,
    props<{ error: ProductError }>()
);

export const SetProductPageViewed = createAction(
    ProductActionTypes.SET_PRODUCT_PAGE_VIEWED,
    props<{ productsViewed: Product[] }>()
);

export const ProductPageAddToCart = createAction(
    ProductActionTypes.PRODUCT_PAGE_ADD_TO_CART,
    props<{ product: Product; sku: number; openPopup: boolean }>()
);

export const SetColorOnSelectedProduct = createAction(
    ProductActionTypes.SET_COLOR_ON_SELECTED_PRODUCT,
    props<{ selectedColor: ProductColor }>(),
);

export const SetSizeOnSelectedProduct = createAction(
    ProductActionTypes.SET_SIZE_ON_SELECTED_PRODUCT,
    props<{ selectedSize: ProductSize; openStock?: boolean }>(),
);

export const ResetSelectedProductSize = createAction(ProductActionTypes.RESET_SELECTED_PRODUCT_SIZE);

export const LoadLazyWishlistModule = createAction(ProductActionTypes.LOAD_LAZY_WISHLIST_MODULE);

export const LoadDeliveryInfoModule = createAction(ProductActionTypes.LOAD_LAZY_DELIVERY_INFO_MODULE);

export const OpenSizeGuideModule = createAction(
    ProductActionTypes.OPEN_SIZE_GUIDE_MODULE,
    props<{ product: Product; categoryId?: string }>(),
);

export const ProductViewZoomInAnalytics = createAction(
    ProductActionTypes.PRODUCT_VIEW_ZOOM_IN_ANALYTICS,
    props<{ carouselIndex: number; carouselLength: number; mediaPath: string; photoType: number; product: Product }>(),
);

export const ProductViewNextImageAnalytics = createAction(
    ProductActionTypes.PRODUCT_VIEW_NEXT_IMAGE_ANALYTICS,
    props<{ carouselIndex: number; carouselLength: number; mediaPath: string; photoType: number; product: Product }>(),
);

export const SetErrorProductFailed = createAction(
    ProductActionTypes.SET_ERROR_PRODUCT_FAILED,
    props<{ productFailed: ProductError }>(),
);

export const UpdateProductPrice = createAction(
    ProductActionTypes.UPDATE_PRODUCT_PRICE,
    props<{ product: Product }>()
);

export const UpdateProductPriceSuccess = createAction(
    ProductActionTypes.UPDATE_PRODUCT_PRICE_SUCCESS,
    props<{ productPrice: ProductPrice }>()
);
